"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  fin: {
    accountCloseDateManage: 'Account Close Date Manage',
    reCordcompany: 'Re Cordcompany',
    yearAndMonth: 'Year And Month',
    confirmDate: 'Confirm Date',
    closeAccountDate: 'Close Account Date',
    confirm: 'Confirm',
    cancelConfirm: 'Cancel Confirm',
    financeManagement: 'Finance Management',
    fuelStockManagement: 'Fuel Stock Management',
    fuelStockQuantity: 'Fuel Stock Quantity',
    fuelStockFlow: 'Fuel Stock Flow',
    fuelStockAccount: 'Fuel Stock Account',
    financialReport: 'Financial Report',
    fuelStockStat: 'Fuel Stock',
    shipCharteringStat: 'Ship chartering statistics',
    shipRentingStat: 'Ship renting statistics',
    shipRentingVcStat: 'Ship renting statistics(VC)',
    voyageCostBill: 'Voyage Cost Bill',
    commenceGmt: 'Commence GMT',
    completeGmt: 'Complete GMT',
    monthlyFuelReconciliation: 'Monthly fuel reconciliation',
    monthlyShipBenefits: 'Monthly ship benefits',
    voyageEndTime: 'Voyage End Time',
    flowTime: 'Flow Time',
    laidUpTime: 'Laid Up Time',
    reportTime: 'Report Time',
    operationNo: 'Operation No',
    batchNo: 'Batch No',
    unitPrice: 'Unit Price',
    bunkerSpec: 'Bunker Spec',
    leftQuantity: 'Left Quantity',
    amountMoney: 'Amount Money',
    trendAmount: 'Dynamic Amount',
    laidUpVoyageNo: 'Laid Up Voyage No',
    stockStatus: 'Stock Status',
    fuelQuantity: 'Fuel Quantity',
    trendFuelQuantity: 'Dynamic Fuel Quantity',
    trendFuelPrice: 'Dynamic Fuel Price',
    stockOperate: 'Stock Operation',
    tonOfNumber: 'Number(TON)',
    closeBalance: 'Close Balance',
    trendDate: 'Dynamic Date',
    businessDate: 'Business Date',
    avgPrice: 'Avg Price',
    terminalStockAmount: 'End Stock Amount',
    universalOrderNumber: 'Universal Order No',
    auditStatus: 'Audit Status',
    auditDate: 'Audit Date',
    voucherNo: 'Voucher No',
    openFuelStorage: 'Begin Fuel Storage',
    closeFuelStorage: 'Close Fuel Storage',
    closeBatchAmount: 'Close Batch Amount',
    treadNumber: 'Dynamic Quantity',
    openQuantity: 'Begin Quantity',
    dynamicQuantity: 'Dynamic Quantity',
    endQuantity: 'End Quantity',
    endStockQuantity: 'End Stock Quantity',
    beginAmount: 'Begin Amount',
    fuelSequenceManage: 'Fuel Sequence Manage',
    fuleMonthlyManage: 'Fuel Monthly Manage',
    sequence: 'Sequence',
    fuelDealStatus: 'Fuel Deal Status',
    previousOperation: 'Previous Operation',
    previousOpreationTime: 'Previous Operation Time',
    sequenceDetail: 'Sequence Detail',
    fuelQuantityDetail: 'Fuel Quantity Detail',
    fourBunkerQuantity: 'Bunker Quantity',
    operationTime: 'Operation Time',
    laidUpOperationNo: 'Laid Up Operation No',
    detailType: 'Dynamic Detail Operation',
    currency: 'Currency',
    refuelType: 'Refuel Type',
    company: 'Company',
    stockDetail: 'Stock Detail',
    //数据监控
    dataMonitor: 'Data Monitor',
    universalManagement: 'Universal Management',
    register: 'Register',
    localCheck: 'Local Check',
    sending: 'Sending',
    sendSuccess: 'Send Success',
    sendError: 'Send Error',
    localAdjust: 'Local Adjust',
    writeOffSuccess: 'Write Off Success',
    writeOffFail: 'Write Off Fail',
    discard: 'Discard',
    batchGenerateUniversal: 'Batch Generate Universal',
    oriOrderCode: 'Ori Order Code',
    account: 'Account',
    accountMonth: 'Account Month',
    dataTime: 'Data Time',
    operator: 'Operator',
    scene: 'Secne',
    abstract: 'Abstract',
    baseCurrencyAmount: 'Base Currency Amount',
    redOffsetOrder: 'Red Offset Order',
    status: 'Status',
    supplier: 'Supplier',
    orderNo: 'Order No',
    variety: 'Variety',
    direction: 'Direction',
    debitEntry: 'Debit Entry',
    debitEntryName: 'Debit Entry Name',
    creditEntry: 'Credit Entry',
    creditEntryName: 'Credit Entry Name',
    oriCurrencyAmount: 'Ori Currency Amount',
    noTaxAmount: 'No Tax Amount',
    exTaxAtion: 'Ex Tax Ation',
    exchangeRate: 'Exchange Rate',
    entriesAbstract: 'Entries Abstract',
    companyPropertyCode: 'Company Property Code',
    sendStatus: 'Send Status',
    lastDataDate: 'Last Data Date',
    specialInstrucion: 'Special Instrucion',
    entriesDetail: 'Entries Detail',
    intelligentLoad: 'Intelligent Load',
    accountDetail: 'Account Detail',
    accountType: 'Account Type',
    accountTypeName: 'Account Type Name',
    accountProjectCode: 'Account Project Code',
    accountProjectName: 'Account Project Name',
    inOutRecords: 'In Out Records',
    isControlled: 'Is Controlled',
    orderSource: 'Order Source',
    businessSubject: 'Business Subject',
    materialName: 'Material Name',
    inOutType: 'In Out Type',
    inOutDate: 'In Out Date',
    orderUnitPrice: 'Order Unit Price',
    vesselCode: 'Vessel Code',
    vesselName: 'Vessel Name',
    interfaceType: 'Interface Type',
    //暂估
    refreshReport: "Refresh Report",
    refreshReportAll: "Refresh All",
    refreshReportVsl: "Refresh Vessel",
    refreshReportVoy: "Refresh Voyage",
    refreshReportTc: "Refresh TC",
    checkShip: "Check Ship",
    monthEstimateManage: 'Month Estimate Manage',
    shipEstimateManage: 'Ship Estimate Manage',
    generateVoyageEstimate: 'Generate Voyage Estimate',
    vcEstimate: 'VC Estimate',
    tcEstimate: 'TC Estimate',
    voyageInfo: 'Voyage Information',
    preCompany: 'Company',
    reportType: 'Report Type',
    reportNo: 'Repoart No',
    preDept: 'Organization',
    checkOutDate: 'Check Out Date(GMT+0)',
    mainBusiness: 'Main Business',
    voyageTotalTime: 'Voyage Total Time',
    establishmentDate: 'Establishment Date',
    deliveryDate: 'Delivery Date',
    redeliveryDate: 'Redelivery Date',
    businessType: 'Business Type',
    voyageType: 'Voyage Type',
    personStatistic: 'Person Statistic',
    cargo: 'Cargo',
    cargoQuantity: 'Cargo Quantity',
    feeItem: 'Fee Item',
    routeName: 'Route Name',
    voyageCurrency: 'Voyage Currency',
    exportTime: 'Export Time',
    pocEstimate: 'POC Estimate',
    noInvoiceEstimate: 'No Invoice Estimate',
    portCharge: 'Port Fee',
    voyageIncidental: 'Voyage Incidental',
    portIncidental: 'Port/Incidental Fee',
    bunkerFee: 'Bunker Fee',
    income: 'Income',
    cost: 'Cost',
    reportAmount: 'Report Amount',
    pocAmount: 'POC Amount',
    thisMonthEstimateAmount: 'This Month Estimate Amount',
    estimateReceiptNo: 'Estimate Receipt No',
    estimateReceiptAmount: 'Estimate Receipt Amount',
    receiptErrorMessage: 'Receipt Failed Generate Reason',
    freightDemurrage: 'Freight/Demurrage',
    contractInvoice: 'Freight/Demuurge Contract',
    charterer: 'Charterer',
    invoiceType: 'Invoice Type',
    invoiceAmount: 'Invoice Amount',
    incomeReceiptNo: 'Income Receipt No',
    thisMonthWriteOffAmount: 'This Month Write Off Amount',
    recepitNumber: 'Receipt Number',
    receiptWriteOff: 'ReceiptWriteOff',
    writeOff: 'Write Off',
    needConfirmAmount: 'Need Confirm Amount',
    isNeedConfirm: 'Is Need Confirm',
    confirmReceiptStatus: 'Confirm Receipt Status',
    confirmReceiptAmount: 'Cpnfirm Receipt Amount',
    isNeedEstiamte: 'Is Need Estimate',
    estimateReceiptStatus: 'Estimate Receipt Status',
    estimateNo: 'Estimate No',
    //orderNo: 'Order No',
    feeType: 'Fee Type',
    portName: 'Port Name',
    oriCurrency: 'Ori Currency',
    orderAmount: 'Order Amount',
    invoiceIsAll: 'Invoice Is All',
    invoiceNo: 'Invoice No',
    supplierCode: 'Supplier Code',
    costQuantity: 'Cost Quantity',
    bunkerCostAmount: 'Bunker Cost Amount',
    pocOriCurrency: 'POC Ori Currency',
    pocTax: 'POC Tax',
    paymentAmount: 'Payment Amount',
    previousPocAmount: 'Previous POC Amount',
    previousPocTax: 'Previous POC Tax',
    thisMonthOriCurrencyAmount: 'This Month Ori Currency Amount',
    oilSupplier: 'Oil Supplier',
    financeDataCompare: 'Finance Data Compare',
    diffNumber: 'Different Number',
    businessData: 'Business Date',
    financeData: 'Finance Date',
    vesselSource: 'Vessel Source',
    generateReceipt: 'Generate Receipt',
    parentSubjectName: 'Parent Subject Name',
    feeSubjectCode: 'Fee Subject Code',
    feeSubjectName: 'Fee Subject Name',
    feeSubjectNameEn: 'Fee Subject En Name',
    enterBusinessCode: 'Please Pass Business Code',
    enterDeptInfo: 'Please Pass Dept Info',
    previousRecoilAmount: 'Previous Recoil Amount',
    laidUpStartTime: 'Laid Up Start Time',
    laidUpEndTime: 'Laid Up End Time',
    belongDate: 'Belong Date',
    estimateType: 'Estimate Type',
    estimateVersion: 'Estimate Version',
    dataStatus: 'Data Status',
    refreshDate: 'Refresh Date',
    orderDealDate: 'Order Deal Date',
    errorOrderNo: 'Error Order No',
    receiptGenerateStatus: 'Receipt Generate Status',
    receiptSendStatus: 'Receipt Send Status',
    deliveryVoyageNo: 'Delivery Voyage No',
    newestRentInvoice: 'Newest Rent Invoice',
    newestRentStart: 'Newest Rent Start',
    newestRentEnd: 'Newest Rent End',
    contractExecuteStatus: 'Contract Execute Status',
    contractCurrencyCode: 'Contract Currency Code',
    dayRentAmount: 'Day Rent Amount',
    needEstimateAmount: 'Need Estimate Amount',
    engineAuditPass: 'Engine Audit Pass',
    engineAuditReturn: 'Engine Audit Return',
    universalDetail: 'Universal Detail',
    estimatePortFee: 'Estimate Port Fee',
    actualPortFee: 'Actual Port Fee',
    invoiceDate: 'Invoice Date',
    createTime: 'Create Time',
    //月结航次检查
    companyCode: 'Company Code',
    checkBeforeChartMonth: 'Check Before Chart Month',
    insuranceEstimate: 'Insurance Estimation',
    insuranceDetail: 'Detail',
    generateVirtual: 'Generate Virtual',
    generateUniversal: 'Generate Universal',
    offsetUniversal: 'Offset Universal',
    generate: 'Generate',
    reportExists: 'Record already exists',
    reportNotExists: 'No eligible ship insurance agreement',
    month: 'Month',
    companyName: 'Company Name',
    involvedMonthShips: 'Involved Month Ships',
    involvedMonthVoyages: 'Involved Month Voyages',
    voyagesCheckPassed: 'Voyages Check Passed',
    estimatesGenerated: 'Submit Finance',
    reportCreationTime: 'Report Creation Time',
    reportUpdateTime: 'Report Update Time',
    generateReports: "Generate Report",
    generateEstimate: 'Generate Estimate',
    submitFinance: 'Submit Finance',
    shipPlausibilityInspection: 'Ship Inspection',
    voyageBusinessInspection: 'Voyage Inspection',
    reportInspection: 'Report Inspection',
    fuelinspection: 'Fuel Inspection',
    portFeeInspection: 'portFeeInspection',
    auditor: 'Auditor',
    shipStatus: 'Ship Status',
    latestVoyageStatus: 'Latest Voyage Status',
    latestVoyageTime: 'Latest Voyage Time',
    latestVoyageTimeBegin: 'Latest Voyage Time Begin',
    latestVoyageTimeEnd: 'Latest Voyage Time End',
    yesOrNoCheck: 'Yes Or No Check',
    cause: 'Cause',
    voyageCheckStatus: 'Voyage Yes Or No Check',
    vesselCheck: 'Vessel Yes Or No Check',
    tcCheckStatus: 'TC Yes Or No Check',
    notPassReasons: 'Not Pass Reasons',
    voyageCheckRefreshTime: 'Voyage Check Refresh Time',
    yesOrNoGenerated: 'Yes Or No Generated',
    buildDate: 'Build Date',
    monthEndReason: 'Month End Reason',
    estimateAmount: 'Future Amount',
    detailsPage: 'Details Page',
    allChoice: 'All Choice',
    allPassedChoice: 'All Passed Choice',
    allPassedChoice0: 'All Passed No Generate',
    allNotPassedChoice: 'All Not Passed Choice',
    dataFrom: 'Date From',
    loadingTime: 'Loading Time',
    lastInvoiceTime: 'Latest update time',
    reportStatus: 'Report Status',
    voyageStatus: 'Voyage Status',
    reportSource: 'Estimate Source',
    latestReportAuditTime: 'Latest Report Created Time',
    reportNotPassResons: 'Report Not Pass Resons',
    fuelStatus: 'Fuel Status',
    fuelNotPassResons: 'Fuel Not Pass Resons',
    portOtherFeeStatus: 'Port Other Fee Status',
    portOtherFeeNotPassResons: 'Port Other Fee Not Pass Resons',
    estimateGenerateReason: 'Estimation Failed Reason',
    isWriteOff: "IS WRITE OFF",
    failReason: "Fail reason",
    checkType: "Check Type",
    writeOffId: 'Write Off Id',
    remark: 'Remark',
    accountDate: 'Account Date',
    selectOne: 'Please select a record',
    generateEstimateFail: 'Failed to submit Finance',
    generateEstimateSuccess: 'Financial submission successful.',
    generateEstimateResult: 'Success：{0},Fail：{1}',
    executeFail: 'Execution failed.',
    executeSuccess: 'Execution succeeded.',
    executeResult: 'Success：{0},Fail：{1}',
    // 期租检查
    timeCharterInspection: 'TC Inspection',
    vesselName2: 'Vessel',
    voyageNo: 'Voyage No',
    companyNameCn: 'Company',
    fleet: 'Fleet',
    contractType: 'Charter Type',
    participateReason: 'Participate Reason',
    actDelTime: 'Delivery Date',
    actRedTime: 'Relivery Date',
    estimateGenerateFlag: 'Estimate Generate',
    estimateGenerateDate: 'Generate Date',
    lastestInvoiceNo: 'Latest Invoice No.',
    lastestInvoiceDate: 'Latest Invoice Date',
    finalFlag: 'Final Invoice',
    periodFrom: 'Period From',
    periodTo: 'Period To',
    submitFlag: 'Invoice Submit Status',
    // 财务暂估
    ispFleetName: '经营公司',
    statisticalMonth: '统计月份',
    insYear: '保险年度',
    hmCount: 'H&M Premium协议份数',
    ivCount: 'I&V Premium协议份数',
    warCount: 'WAR Premium协议份数',
    piCount: 'P&I Call协议份数',
    fddCount: 'FDD Call协议份数',
    invoicedCount: '已来发票协议数',
    completeCount: '发票来齐协议数',
    universalCount: '已生成万能单数',
    // 财务暂估明细
    insureType: '保险类型',
    insurerName: '保险商',
    brokerName: '经纪人',
    isSigned: '是否已签订协议',
    startDate: '协议开始时间',
    endDate: '协议结束时间',
    amount: '协议金额',
    brokerAmount: '经纪人佣金',
    invoiceComplete: '发票是否来齐',
    invoiceCompleteNum: '发票已来期数',
    insFlag: '协议数/发票数',
    monthCost: '本月已进保费成本',
    estimateCost: '本月应进保费成本',
    offsetCost: '本月暂估保费成本',
    receiptNo: '万能单号',
    receiptAmount: '万能单金额',
    receiptStatus: '万能单发送状态',
    selectVirtual: 'Please select virtual protocol',
    selectReceiptNull: 'Please select record with empty receipt no.',
    selectReceiptNotNull: 'Please select a universal order record that has been generated.',
    cancelReceipt: 'Are you sure to cancel receipt no: ',
    generateFlag: 'Generate/Offset success',
    generateReason: 'Generate/Offset fail reason',
    checkPassSelectVC: 'Please select the voyage inspection pass record.',
    checkPassSelectTC: 'Please select the TC inspection pass record.',
    //航次数据更新
    voyageDataUpdate: 'Voyage Data Update',
    thisPeriodRedShow: 'This Period Red Show',
    payApplicationDate: 'Pay Application Date',
    batchApprove: 'Batch Approve',
    batchUpdate: 'Batch Update',
    previousDate: 'Previous Period Date',
    thisDate: 'This Period Date',
    previoueRevenue: 'Previous Period Revenue',
    thisRevenue: 'This Period Revenue',
    previousExpense: 'Previous Period Expense',
    thisExpense: 'This Period Expense',
    previousDayTce: 'Previous Period Day Tce',
    thisDayTce: 'This Period Day Tce',
    dataUpdateError: 'Update Error Reason'
  }
};